<template>
  <div v-if="message.length > 0">
    <p class="chat-history__item">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'ChatHistoryItem',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.chat-history__item {
  border-left: 2px solid var(--main-red);
  color: var(--chat-history-text);
  font-size: 18px;
  line-height: normal;
  text-align-last: left;
  padding: 10px 20px;
  box-sizing: border-box;
  margin: 0;
  margin-bottom: 10px;
}
</style>
